var _ellipse, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 37,
    rx: 13,
    ry: 1,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9531 15.0753C38.4901 10.5391 34.6584 7 30 7C25.5237 7 21.8107 10.2679 21.1165 14.5481C20.316 14.1957 19.4308 14 18.5 14C14.9101 14 12 16.9101 12 20.5C12 20.5854 12.0016 20.6704 12.0049 20.755C12.0016 20.8363 12 20.9179 12 21C12 24.3137 14.6863 27 18 27H18.5H38C41.3137 27 44 24.3137 44 21C44 18.0106 41.8138 15.5319 38.9531 15.0753Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04693 8.07528C5.5099 3.53914 9.34165 0 14 0C18.4763 0 22.1893 3.26789 22.8835 7.5481C23.684 7.19566 24.5692 7 25.5 7C29.0899 7 32 9.91015 32 13.5C32 13.5854 31.9984 13.6704 31.9951 13.755C31.9984 13.8363 32 13.9179 32 14C32 17.3137 29.3137 20 26 20H25.5H6C2.68629 20 0 17.3137 0 14C0 11.0106 2.18616 8.53188 5.04693 8.07528Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28,
    y1: 15,
    x2: 28,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.846a4829deaf78ff9af34ad1ceb7af11.svg";
export { ForwardRef as ReactComponent };